import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BusinessFilterModel, BusinessGroupedModel } from '@features/business/models/business.model';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { BusinessLogo } from "@shared/components/business-logo/business-logo";

@Component({
  selector: 'app-business-filter',
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    MultiSelectModule,
    ButtonModule,
    BusinessLogo
],
  templateUrl: './business-filter.html',
  styleUrl: './business-filter.scss',
})
export class BusinessFilter {
  businessGroupOptions = input<BusinessGroupedModel[]>([]);
  loading = input<boolean>(false);

  filterChange = output<BusinessFilterModel>();
  clearFilters = output<void>();

  searchText: string = '';
  selectedBusinessGroups: string[] = [];

  handleFilter() {
    const filterValues: BusinessFilterModel = {
      searchText: this.searchText.trim() || undefined,
      selectedBusinessGroups: this.selectedBusinessGroups?.length > 0 ? this.selectedBusinessGroups : undefined,
    };

    // Emitir los valores al componente padre
    this.filterChange.emit(filterValues);
  }

  handleClear(): void {
    this.searchText = '';
    this.selectedBusinessGroups = [];
    this.clearFilters.emit();
  }
}
